<div class="sgt-canal-venda-select dropdown"
    [class.invalid]="!isValid">
    <button class="btn btn-light dropdown-toggle" #dropdownToggle type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">
        <ng-template [ngIf]="canalVenda">
            <span>
                <sgt-canal-venda-logo-badge
                  [logoMiniURL]="canalVenda.logoMiniURL"
                  [useAsMini]="true"
                  [isShowNome]="false"
                  [nome]="canalVenda.nome"
                  [styles]="{
                      width: '25px',
                      height: '25px'
                  }">
                </sgt-canal-venda-logo-badge>
            </span>
            <span>
              {{canalVenda.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!canalVenda">
            <span>
                Nenhum Canal de Venda
            </span>
        </ng-template>
    </button>

    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item"
                    [class.dropdown-item-select]="!idCanalVenda"
                    (click)="select(null)">
                    Nenhum Canal de Venda
                </a>
                <a *ngFor="let option of options"
                    class="dropdown-item"
                    [class.dropdown-item-select]="option.id == idCanalVenda"
                    (click)="select(option)">
                    <span>
                        <sgt-canal-venda-logo-badge
                            [logoMiniURL]="option.logoMiniURL"
                            [useAsMini]="true"
                            [isShowNome]="false"
                            [nome]="option.nome"
                            [styles]="{
                                width: '25px',
                                height: '25px'
                            }">
                        </sgt-canal-venda-logo-badge>
                    </span>
                    <span>
                        {{option.nome}}
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>